import { styled, Typography } from "@mui/material";

// ✅ Primary Bold Text (section titles or labels)
export const TextStyled = styled(Typography)(({ theme }) => ({
  fontFamily: "Nunito Sans, sans-serif",
  fontWeight: 700,
  fontStyle: "normal",
  fontSize: "13px",
  lineHeight: "20px",
  // letterSpacing: "0.89px",
  textTransform: "capitalize",
  color: "#000000",

  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
    lineHeight: "22px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "16px",
    lineHeight: "24px",
  },
}));

// ✅ Large Orange Title (Highlight section)
export const OrangeTitleHighlights = styled(Typography)(({ theme }) => ({
  fontFamily: "Nunito Sans, sans-serif",
  fontWeight: 800,
  fontSize: "24px",
  lineHeight: "28px",
  // letterSpacing: "0.6px",
  textTransform: "capitalize",
  color: "#F57C00",

  [theme.breakpoints.up("sm")]: {
    fontSize: "30px",
    lineHeight: "34px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "35px",
    lineHeight: "42px",
  },
}));

// ✅ Subtitle or Secondary Text
export const SubTextHighlights = styled(Typography)(({ theme }) => ({
  fontFamily: "Nunito Sans, sans-serif",
  fontWeight: 500,
  fontSize: "13px",
  lineHeight: "18px",
  color: "#555555",

  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
    lineHeight: "20px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "20px",
    lineHeight: "26px",
  },
}));

// ✅ Orange Highlighted Title (for quick highlights)
export const OrangeTitleQuickHighlights = styled(Typography)(({ theme }) => ({
  fontFamily: "Nunito Sans, sans-serif",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "22px",
  // letterSpacing: "0.6px",
  textTransform: "capitalize",
  color: "#ffffff",

  [theme.breakpoints.up("sm")]: {
    fontSize: "18px",
    lineHeight: "24px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "20px",
    lineHeight: "26px",
  },
}));

// ✅ Subtitle or Secondary Text (for quick highlights)
export const SubTextQuickHighlights = styled(Typography)(({ theme }) => ({
  fontFamily: "Nunito Sans, sans-serif",
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "18px",
  color: "#ffffff",

  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
    lineHeight: "20px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "15px",
    lineHeight: "22px",
  },
}));
